var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container flex-center"},[_c('main-header',{staticClass:"i-h"}),(_vm.url)?_c('video',{attrs:{"play":"","controls":"","src":_vm.url}}):_c('div',[_vm._v("播放链接无效")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }